import React from 'react';
import { Link } from 'react-router-dom';

const guideGroups = [
  {
    app: 'How to use Driver App',
    description: 'For drivers accepting work and completing deliveries.',
    guides: [
      {
        title: 'Instant Trips',
        to: '/how-it-works/driver-app/instant-trips',
        active: true,
      },
      {
        title: 'Offer Trips',
        to: '/how-it-works/driver-app/offer-trips',
        active: false,
      },
    ],
  },
  {
    app: 'How to use User App',
    description: 'For customers booking and tracking deliveries.',
    guides: [
      {
        title: 'Instant Booking',
        to: '/how-it-works/user-app/instant-booking',
        active: false,
      },
      {
        title: 'Scheduled Booking',
        to: '/how-it-works/user-app/scheduled-booking',
        active: false,
      },
    ],
  },
];

const HowItWorksDeepDive: React.FC = () => {
  return (
    <section className="driver-how-library" aria-labelledby="guide-library-title">
      <div className="container">
        <div className="driver-how-library-head">
          <span className="sw-eyebrow">Choose a guide</span>
          <h2 id="guide-library-title">Start with the flow you need.</h2>
        </div>

        <div className="driver-how-guide-grid">
          {guideGroups.map((group) => (
            <article className="driver-how-guide-card" key={group.app}>
              <div className="driver-how-guide-card-head">
                <h3>{group.app}</h3>
                <p>{group.description}</p>
              </div>

              <div className="driver-how-guide-chips">
                {group.guides.map((guide) => (
                  <Link
                    className={`driver-how-guide-chip${guide.active ? ' driver-how-guide-chip-active' : ''}`}
                    to={guide.to}
                    key={guide.title}
                  >
                    <span>{guide.title}</span>
                  </Link>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksDeepDive;
